import script from "./TdsVdsList.vue?vue&type=script&setup=true&lang=js"
export * from "./TdsVdsList.vue?vue&type=script&setup=true&lang=js"

import "./TdsVdsList.vue?vue&type=style&index=0&id=550c2bd4&lang=css"

const __exports__ = script;

export default __exports__